export default function AboutStory() {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Our Story
            </h2>
            <div className="space-y-4 text-gray-700 text-base leading-relaxed">
              <p>
                KaliKare Homecare was founded with a simple yet powerful mission: to provide exceptional, 
                personalized care that allows individuals to maintain their independence and dignity in the 
                comfort of their own homes.
              </p>
              <p>
                Our journey began when our founders, Yana and Yasmeen, recognized the growing need for 
                high-quality homecare services that truly put clients first. With backgrounds in healthcare 
                and a deep commitment to serving their community, they established KaliKare to bridge the 
                gap between clinical excellence and compassionate, personalized care.
              </p>
              <p>
                Today, KaliKare stands as a trusted provider in the Greater Philadelphia area, serving 
                families with dedication, professionalism, and heart. We've built our reputation on 
                reliability, quality care, and the genuine relationships we form with every client and 
                their family.
              </p>
              <p>
                Every member of our team shares our commitment to excellence and our belief that quality 
                homecare can transform lives. We're not just caregivers—we're partners in your journey 
                toward health, independence, and peace of mind.
              </p>
            </div>
          </div>
          
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/bca70504d20b745a2d2886f680e0f3c6.jpg"
                alt="KaliKare Team"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#5C4F8A] text-white p-8 rounded-2xl shadow-xl max-w-xs">
              <p className="text-4xl font-bold mb-2">10+</p>
              <p className="text-sm">Years of Combined Healthcare Experience</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}